import { render, staticRenderFns } from "./view-master.vue?vue&type=template&id=6c8dd2d0&scoped=true&"
import script from "./view-master.vue?vue&type=script&lang=js&"
export * from "./view-master.vue?vue&type=script&lang=js&"
import style0 from "./view-master.vue?vue&type=style&index=0&id=6c8dd2d0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8dd2d0",
  null
  
)

export default component.exports